import Vue from 'vue';
import * as news from "../../../static/json/news.json";
//模块：新闻资讯
export default Vue.extend({
    name: "index",
    data: function () {
        return {
            crtMenu: 'n1',
            newsList: news["news"],
        };
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：切换菜单
         * @param val
         */
        setMenu: function (val) {
            this.crtMenu = val;
        },
    },
    computed: {
        menuList: function () {
            return this.$t('newsmenu');
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/news/index.vue
// module id = null
// module chunks = 